module.exports = __webpack_public_path__ + "static/img/pay_success.429e7fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicClass/pay_success.png
// module id = JAxA
// module chunks = 23